<template>
  <div v-if="item">
    <div class="border">
      <h6>
        {{ "phone" | setText("Номер телефона") }}:
        <span class="text-info">{{ item.client_phone }}</span>
      </h6>
      <h6>
        {{ "type_insurance" | setText("Тип страхования") }}:
        <b> {{ item.type | insurance }}</b>
      </h6>
      <h6>
        {{ "paid_at" | setText("Дата  оплаты") }}:
        {{ item.paid_at | dateFormat }}
      </h6>
      <h6>
        {{ "client" | setText("Покупатель") }}: {{ item.client_first_name }}
        {{ item.client_last_name }} {{ item.client_family_name }}
      </h6>
      <h6>{{ "PINFL" | setText("ПИНФЛ") }}: {{ item.client_pinfl }}</h6>
      <h6>{{ "passport" | setText("Паспорт") }}: {{ item.client_passport }}</h6>

      <h6>
        {{ "birthday" | setText("Дата рождения") }}:
        {{ item.client_birthday | dateFormat }}
      </h6>
    </div>

    <div :class="`border ${item.state == 'new' ? '' : 'opacity'}`">
      <h4>
        {{ "insurance_step_1" | setText("1. Детали товара и стоимость") }}
      </h4>


      <price
        v-model="item"
        @input="updateItem(['price', 'date_paid', 'type_object'])"
      />
    </div>
    <div :class="`border ${item.price == 0 ? 'opacity' : ''}`">
      <h4>
        {{ "insurance_step_2 " | setText("2. Сформировать запрос") }}
      </h4>
      <component
        v-if="item.service"
        :is="item.service.code"
        :data="item"
        v-model="value"
        @input="serviceUpdateItem"
      />
    </div>
  </div>
</template>

<script>
import { cardContent, toFormData, errorNotify } from "@/plugins/functions";

export default {
  components: {
    price: () => import("@/components/Services/apex/Fields/Price"),
    apex: () => import("@/components/Services/apex"),
  },
  data: () => ({
    cardLink: "insurance_orders",
    item: null,
    value: {},
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardContent: cardContent,
    async serviceUpdateItem() {
      this.$loading(true);
      return this.$http({
        method: "post",
        data: toFormData({ _method: "put", ...this.value }),
        url: `${this.cardLink}/${this.id}`,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.item = response.data.data;
          return response.data;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },

    async updateItem(keys = []) {
      let data = {};

      for (let i = 0; i < keys.length; i++) {
        data[keys[i]] = this.item[keys[i]];
      }

      this.$loading(true);
      return this.$http({
        method: "post",
        data: toFormData({
          _method: "put",
          ...data,
        }),
        url: `${this.cardLink}/${this.id}`,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.$notify({
            title: "Успешно",
            message: "Вы успешно применили данные",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
          });

          this.item = response.data.data;

          return response.data;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>

